import { isUrlExternal } from 'pathfinder/modules/SponsoredWidgets/helpers/isUrlExternal';
import { useMemo } from 'react';
export function useIsUrlExternal(href) {
    return useMemo(() => isUrlExternal(href), [href]);
}
